import Banner from './Banner'
import ListProducts from './ListProducts'
import { imgCategory } from '../../assets'
import { Link } from 'react-router-dom'
const HomePage = () => {
    const Category = [imgCategory.TatCaSP, imgCategory.DoTheThao, imgCategory.MacHangNgay, imgCategory.DoLot]

    return (
        <>
            <Banner className="h-[200px] sm:h-[400px] md:h-[500px] lg:h-[600px] xl:h-[700px]" />
            <ListProducts />
            {/* {data && (
                <OutstandingProducts
                    title="ĐỒ CHẠY BỘ"
                    description="Trải nghiệm chưa từng có trong mỗi sải chân"
                    poster={images.DoChayBo}
                    data={data.running}
                />
            )} */}
            {/* {data && (
                <OutstandingProducts
                    title="QUẦN DÀI NAM"
                    description="Tạo nên những bộ outfit cực cool cho chàng"
                    poster={images.DoChayBo}
                    data={data.running}
                />
            )} */}
            {Category && (
                <div
                    className="mx-4 mb-10 mt-10 grid grid-cols-2 gap-4 
      md:grid-cols-4  lg:mt-0"
                >
                    {Category.map((item) => (
                        <Link className="relative" key={item}>
                            <img className="h-full w-full rounded-sm object-cover" src={item} alt="" />
                            <div className="absolute top-0 h-full w-full rounded-sm hover:bg-black hover:opacity-20"></div>
                        </Link>
                    ))}
                </div>
            )}
        </>
    )
}

export default HomePage
